// ============= Imports =============
import { AuthContextProps } from '@/contexts/AuthContext';
import { tokenManager } from '@tw/tw-component-library';

// ============= Constants =============
const BASE_URL = import.meta.env.VITE_BASE_CORE_URL;
const API_ENDPOINT = '/api/Workspace';
const LITIUM_SCOPE = import.meta.env.VITE_LITIUM_CORE_SCOPE;

const HEADERS = {
  'Content-Type': 'application/json',
};

// ============= Types =============

export interface PatchIsOwnerProps {
  getAccessToken: AuthContextProps['getAccessToken'];
  workspaceId: string;
  userId: string;
  isOwner: boolean;
}

// ============= Utility Functions =============
/**
 * Creates headers for API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
/**
 * Updates is owner
 * @param getAccessToken Function to acquire access token
 * @param workspaceId Workspace ID
 * @param userId User ID
 * @param isOwner Whether the user is an owner
 * @returns Promise with void
 */
export const patchIsOwner = async ({
  getAccessToken,
  workspaceId,
  userId,
  isOwner,
}: PatchIsOwnerProps): Promise<void> => {
  try {
    console.log('🔄 Updating is owner...');

    // Token acquisition with required scopes
    const token = await getAccessToken([LITIUM_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire API token');
    }
    tokenManager.logTokenInfo(token, 'API');

    // URL construction
    const url = `${BASE_URL}${API_ENDPOINT}/${workspaceId}/user/${userId}/isOwner/${isOwner}`;
    const convertURI = encodeURI(url);
    console.log('🌐 Making request to:', convertURI);

    // API request
    const response = await fetch(convertURI, {
      method: 'PATCH',
      headers: createHeaders(token),
    });

    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    console.log(`✅ Is owner updated successfully`);
  } catch (error) {
    console.error('🔴 Error updating is owner:', error);
    throw new Error(`Error updating is owner: ${error}`);
  }
};
